// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1uzJl","alertIcon":"ConfirmModal_alertIcon__TqDwh"};